import cx from 'classnames';
import { MenuItem } from 'components/shared/Menu';
import CheckmarkIcon from 'icons/CheckIcon';
import { noop } from 'lodash-es';
import { Text } from '../typography';

type MenuItemProps = {
  selected?: boolean;
  onSelect?: (value: unknown) => void;
  value: unknown;
  text: string | React.ReactNode;
};

const FilterMenuButton = ({
  selected = false,
  onSelect = noop,
  value,
  text
}: MenuItemProps) => {
  const optionClasses = cx('mt-1 flex cursor-pointer items-center pb-1 pt-1', {
    'item-selected text-blue-500 hover:text-blue-900': selected,
    'item pl-6 hover:text-gray-700': !selected
  });

  return (
    <MenuItem onSelect={() => onSelect(value)} className={optionClasses}>
      {selected && (
        <CheckmarkIcon
          variant="default"
          className="mr-2 h-4 w-4 shrink"
          ariaHidden
        />
      )}
      <Text size="m">{text}</Text>
    </MenuItem>
  );
};

export default FilterMenuButton;
